import React from 'react';
import Header from "../components/UI/Header/Header";
import CurrencyInfoSection from "../components/CurrencyInfoSection/CurrencyInfoSection";

const CurrencyInfoPage = () => {
    return (
        <div>
            <Header/>
            <CurrencyInfoSection/>
        </div>
    );
};

export default CurrencyInfoPage;